import React from "react";

export default function UboldSpinner(props) {
  return <div className="spinner-border text-info mt-2 mr-2" role="status"></div>;
};